import { toDecimal } from 'dinero.js'

import type { Money } from '#money/money'

/**
 * Render `Money` for a reader, at **the registry's** exponent rather than ISO's.
 *
 * Bare `Intl` takes the ISO exponent, so IDR comes out as `Rp 1.665.000,00` — two decimals of a
 * sub-unit Indonesia does not use (see `currency.ts`). Going through Dinero pins the fraction
 * digits to the currency this package declared, so the screen and the ledger agree.
 *
 * Throws `RangeError` on a locale tag `Intl` does not recognize; display callers catch it.
 */
export function formatMoney(value: Money, locale?: string): string {
  return toDecimal(value, ({ value: decimal, currency }) =>
    new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency.code,
      minimumFractionDigits: currency.exponent,
      maximumFractionDigits: currency.exponent,
    }).format(Number(decimal)),
  )
}
